import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

interface HeroSectionProps {
  searchTerm: string
  onSearchChange: (value: string) => void
  onClearSearch: () => void
}

/**
 * Hero section with gradient background and search functionality
 */
export function HeroSection({ searchTerm, onSearchChange, onClearSearch }: HeroSectionProps) {
  return (
    <section className="hero-critical">
      <div className="relative container mx-auto px-4 text-center">
        <h1 className="hero-title">
          Find Your Next Creative Gig
        </h1>
        <p className="hero-subtitle">
          Connect with independent filmmakers and video creators. Discover opportunities in short
          films, features, and YouTube productions.
        </p>
        <p className="text-lg md:text-xl mb-8 opacity-90 max-w-2xl mx-auto">
          Opportunities include both paid gigs and unpaid portfolio-building projects.
        </p>

        {/* Search Bar */}
        <div className="max-w-2xl mx-auto flex flex-wrap gap-3 sm:gap-4">
          <div className="relative flex-1 min-w-[240px]">
            <Input
              placeholder="Search jobs by title, role, or location"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="h-12 text-lg bg-background/95 text-foreground border-0 shadow-lg backdrop-blur-sm w-full"
            />
          </div>
          <Button
            onClick={onClearSearch}
            variant="secondary"
            className="h-12 px-6 bg-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/30 border border-primary-foreground/60 backdrop-blur-sm font-bold rounded-lg w-full sm:w-auto"
          >
            Clear
          </Button>
        </div>
      </div>
    </section>
  )
}
